import { gsap } from 'gsap';

window.menuNav = new (function () {
    this.init = function () {



        $('header nav a').on('click', function (e) {
            if ($(this).hasClass('current') && window.outerWidth <= 991 || $(this).hasClass('current') && window.outerHeight <= 620) {
                $('.main-header .btn-menu').trigger('click');
                e.preventDefault();
                return false;
            }
        });

        $('body').on('click', 'header.open nav', function (e) {
            $('.main-header .btn-menu').trigger('click');
        });

        $(document).on('click', function (event) {
            if ($('.main-header').hasClass('open') && $(event.target).closest('.main-header').length === 0) {
                window.menuNav.hide();
            }
        });

        $('body').on('click', 'a[hreflang]', function (e) {
            console.log($(this).val());
            e.preventDefault()
            e.stopPropagation()
            window.barba.instance.force($(this).attr('href'));
        })

        $('.btn-menu').on('click', function (e) {
            e.preventDefault();
            if ($(this).hasClass('open')) {
                window.menuNav.hide();

            } else {
                window.menuNav.show();
                $(".main-header").addClass('open');
            }
        })
        $('header nav').find('a.current').on('click', function () {
            $('.btn-menu').trigger('click');
        })

    }
    this.menuResizeHandler = function () {
        console.log('ici');
        $('.main-header .btn-menu').removeClass('open')
        gsap.set($('.main-nav-center'), { clearProps: "all" });
        gsap.set($('.menu-item a'), { clearProps: "all" });

        //this.hide();


    }
    this.timeline = gsap.timeline({ paused: true });





    this.show = function () {
        this.timeline.paused(false)
        this.timeline.reversed(false)
        $('.main-header .btn-menu').addClass('open')


    }
    this.hide = function () {


        return new Promise((resolve) => {
            if ($('.main-header .btn-menu').hasClass('open') != true) {
                resolve(true);
                return;
            }
            else {
                this.timeline.paused(false)
                this.timeline.reversed(true)
                this.timeline.eventCallback('onReverseComplete', () => {
                    resolve()
                })
                $('.main-header,.btn-menu').removeClass('open')



            }




        });





    }
    this.end = function () {
        this.timeline.seek(1)
        this.timeline.paused(true)
        $(".main-header").addClass('open');
        $(".btn-menu").addClass('open');
    }
    this.reset = function () {



        $('.main-header,.btn-menu').removeClass('open')
        gsap.set('.nav-wrapper', { backgroundColor: 'rgba(0,0,0,0)' })
        gsap.to('.nav-footer', { autoAlpha: 0, })
        gsap.set('header .menu-item a,header .social-list a .wrapper', { yPercent: 110 });
        gsap.set('.main-nav-wrapper', { xPercent: -100 })

    }
    this.updateCurrentLink = function () {

        $('header nav a').removeClass('current');
        $('header nav a').removeClass('current');
        $('header nav a').each(function (index) {
            let elHref = $(this).prop("href")

            if (elHref == document.location.href) {
                $(this).addClass('current');
            }

        })
    }
    this.initView = function () {

    }

})
